import React from 'react'
import NavBar from '../../Components/NavBarComponent/NavBar'
import ForgotPasswordForm from './ForgotPasswordForm'

const ForgotPassword = () => {
  return (<div>
    <NavBar />
    <ForgotPasswordForm />
  </div>)
}

export default ForgotPassword